import Button from '@material-ui/core/Button'
import styled from 'styled-components'

const PrimaryButton = (props) => {
    return (
        <StyledButton 
            color="primary" variant="contained" disabled={props.disabled}
            onClick={ () => props.operation() } 
        >
            {props.label}
        </StyledButton>
    )
}
export default PrimaryButton

const StyledButton = styled(Button)`
    font-size: 16px;
    height: 48px;
    width: 256px;
    @media screen and (max-width:768px){
        width: 192px;
    }
`
